module.exports = __webpack_public_path__ + "images/stop_point_current.478ba224d8d30fbcefb3622360f40205.png";